/**
 * Gateway Error Codes and GatewayError Class
 * Typed error handling for Gateway API operations
 */

export const GatewayErrorCode = {
  AUTH_REQUIRED: 'AUTH_REQUIRED',
  CSRF_MISSING: 'CSRF_MISSING',
  RATE_LIMITED: 'RATE_LIMITED',
  TIMEOUT: 'TIMEOUT',
  INVALID_RESPONSE: 'INVALID_RESPONSE',
  NOT_INITIALIZED: 'NOT_INITIALIZED',
  NETWORK_ERROR: 'NETWORK_ERROR',
  PAYLOAD_TOO_LARGE: 'PAYLOAD_TOO_LARGE',
  SESSION_EXPIRED: 'SESSION_EXPIRED',
  SESSION_ENDED: 'SESSION_ENDED',
  CSRF_REJECTED: 'CSRF_REJECTED',
  FORBIDDEN: 'FORBIDDEN',
  DUPLICATE_NAME: 'DUPLICATE_NAME',
  FOLDER_NOT_EMPTY: 'FOLDER_NOT_EMPTY',
  INVALID_INPUT: 'INVALID_INPUT',
  COMPARE_RUNNING: 'COMPARE_RUNNING',
  NOT_FOUND: 'NOT_FOUND',
} as const;

// eslint-disable-next-line no-redeclare
export type GatewayErrorCode =
  (typeof GatewayErrorCode)[keyof typeof GatewayErrorCode];

export class GatewayError extends Error {
  constructor(
    message: string,
    public readonly code: GatewayErrorCode,
    public readonly details?: Record<string, unknown>
  ) {
    super(message);
    this.name = 'GatewayError';
  }
}

/**
 * Type guard to check if an error is a GatewayError with a specific code
 */
export function isGatewayError(
  error: unknown,
  code?: GatewayErrorCode
): error is GatewayError {
  if (!(error instanceof GatewayError)) return false;
  if (code !== undefined) return error.code === code;
  return true;
}
